import { request } from '../../request';

export type SingleShiftEditData = {
  oriented?: {
    value: boolean;
    locationId: string;
  };
};

export async function updateExternalStaff(staffId: string, data: SingleShiftEditData) {
  return request.patch<void>(`/v2/external/staff/${staffId}`, {
    orientedRecord: {
      locationId: data.oriented?.locationId || null,
      oriented: data.oriented?.value ? 'Yes' : 'No',
    },
  });
}
